import React from 'react';
import PropTypes from 'prop-types';
import Button from 'products/nomad_insurance/components/Button';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import { ButtonsContainer, Paragraph } from './styled';

const AdulthoodConfirmation = ({ isOpen, onClose, onConfirmation }) => (
  <BaseModal
    isOpen={isOpen}
    onClose={onClose}
    heading="Heads up about adding adult group members!"
  >
    <Paragraph>
      Please note that our digital claims process is only accessible from the primary
      member's user dashboard. This means when you add adult group members, medical
      information, banking details, claims updates and other information about you and
      your group members will only be accessible through this account.
    </Paragraph>
    <Paragraph>
      If you'd like each adult group member to manage their own claims, we recommend
      creating separate accounts for each adult and purchasing separately. Don't worry -
      there's no price difference!
    </Paragraph>

    <ButtonsContainer>
      <Button onClick={onClose} variant="textOnly" color="pickledBluewood">
        Back
      </Button>
      <Button onClick={onConfirmation} color="pickledBluewood">
        Agree
      </Button>
    </ButtonsContainer>
  </BaseModal>
);

AdulthoodConfirmation.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirmation: PropTypes.func
};

export default AdulthoodConfirmation;
